import {
  __,
  el,
  ToggleControl,
} from '../../common/variables';
import { cl } from '../../common/functions';

const editFilters = (props) => {
  const { className, isSelected, attributes, setAttributes, setMetaValue } = props;
  return el(ToggleControl,
    {
      label: __('Afficher les filtres ?'),
      className: "toggle-box",
      checked: attributes.filters,
      onChange: (value) => {
        setAttributes({ filters: value });
      }
    }
  )
}

export { editFilters }
